import api from "@src/api/api";
import CompactPost from "@src/pages/news/posts/CompactPost";
import WatchType from "@src/utils/types/watch/WatchType";
import useDebounce from "@src/utils/useDebounce";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useEffect } from "react";

type Props = {
  userId: string;
  searchQuery: string;
};

type Response = {
  data: WatchType[];
  current_page: number;
  total_pages: number;
};
const PostLikes = (props: Props) => {
  const { userId } = props;
  const debouncedSearchQuery = useDebounce(props.searchQuery, 500);

  const list = useInfiniteQuery<Response>(
    [userId, debouncedSearchQuery],
    async ({ pageParam = 0 }) => {
      const { data } = await api.get(
        `/api/v1/watch?liked_by=${userId}&page=${pageParam}&q=${debouncedSearchQuery}`,
      );
      return data;
    },
    {
      getNextPageParam: lastPage => {
        const nextPage = lastPage.current_page + 1;
        return nextPage <= lastPage.total_pages ? nextPage : false;
      },
    },
  );

  const handleScroll = () => {
    const scrollElement = document.getElementsByTagName("main")[0];

    if (list.isFetchingNextPage || !list.hasNextPage) return;

    if (
      Math.abs(scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight) <
      1000
    ) {
      list.fetchNextPage();
    }
  };

  useEffect(() => {
    const scrollElement = document.getElementsByTagName("main")[0];

    if (scrollElement === undefined) return;

    scrollElement.addEventListener("scroll", handleScroll);
    return () => scrollElement.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <div className="mt-2 grid grid-cols-2 gap-4 xl:grid-cols-5">
        {list.data &&
          list.data.pages.map(page =>
            page.data.map((item: WatchType) => (
              <CompactPost
                key={item.media_key}
                id={item.media_key}
                viewCount={item.view_count}
                likeCount={item.like_count}
                image={item.media_thumbnail}
              />
            )),
          )}
      </div>
    </>
  );
};

export default PostLikes;
